export const getHostCardExtItem = (pznOfferList = []) => {
  if (Array.isArray(pznOfferList) && pznOfferList.length > 0) {
    return {
      id: pznOfferList[0].treatmentId,
      compId: pznOfferList[0].componentId,
      iaCode: pznOfferList[0].iaCode
    };
  }

  return {};
};

export const getXSellCardsExtItems = (pznOfferList = []) => {
  if (Array.isArray(pznOfferList) && pznOfferList.length > 0) {
    return pznOfferList.map(pznItem => {
      return {
        id: pznItem.treatmentId,
        compId: pznItem.componentId,
        iaCode: pznItem.iaCode
      };
    });
  }

  return [];
};
